module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[65]552.f71cb28.woff2";